import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import { SearchInput, StatusBullet, SelectAgencyClient } from 'components';
import { Typography, TextField, MenuItem } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
}));

const TemplateToolbar = props => {
  const { 
    className,
    template,
    category,
    onClickFind,
    agencies,
    clients,
    selectedAgency, 
    onChangeAgency,
    selectedClient,
    //onSetSelectedClient,
    onChangeClient,
    ...rest
  } = props;

  const classes = useStyles();

  const [findItemName, setFindItemName] = useState('');

  useEffect(() => {
    setFindItemName('');
  }, [category]);

  return (
    <div>
      <div className={classes.row}>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          광고명
        </Typography>
        <SearchInput
          className={classes.searchInput}
          placeholder=""
          value={findItemName}
          onChange={event => setFindItemName(event.target.value)}
        />
       <Button
        color="primary"
        variant="contained"
        onClick={ () => onClickFind(findItemName, selectedAgency, selectedClient) }
       >
         조회
       </Button>
      </div>

      <SelectAgencyClient 
        agencies={agencies}
        clients={clients}
        valueAgency={selectedAgency}
        onChangeAgency={onChangeAgency}
        valueClient={selectedClient}
        //onSetValueClient={client => onSetSelectedClient(client)}
        onChangeClient={onChangeClient}
        />

    </div>
  );
};

TemplateToolbar.propTypes = {
  className: PropTypes.string
};

export default TemplateToolbar;
